<template>
  <div class="border rounded-lg flex flex-col w-full h-full bg-white">
    <div
      class="h-12 bg-report-bell text-white w-full rounded-t-lg flex justify-between items-center px-4"
    >
      <h5 class="text-base font-bold">Explorer</h5>

      <el-tooltip
        class="item"
        effect="dark"
        content="Hide Explorer"
        placement="top-start"
      >
        <div
          class="cursor-pointer border-white p-1"
          @click="$emit('showSidebar', false)"
        >
          <i class="el-icon-close text-lg font-bold"></i>
        </div>
      </el-tooltip>
    </div>
    <div class="px-4 flex flex-col mt-2">
      <div class="flex flex-col mt-2" v-if="!isCustomer">
        <h5 class="text-base font-bold text-black">Tenant</h5>
        <div class="w-full mt-2">
          <el-select
            v-model="form.customerId"
            filterable
            clearable
            remote
            reserve-keyword
            placeholder="Select Customer"
          >
            <el-option
              v-for="item in customer"
              :key="item.DcoId"
              :label="item.Company"
              :value="item.DcoId"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="flex flex-col">
        <h5 class="text-base font-bold text-black mt-2">Device Groups</h5>
        <el-input class="mt-2" placeholder="Search" v-model="filterText">
        </el-input>

        <div class="border mt-2 max-h-72 overflow-auto">
          <el-tree
            :data="dataTree"
            :props="defaultProps"
            ref="tree"
            node-key="Dce_id"
            default-expand-all
            show-checkbox
            highlight-current
            empty-text="No Data"
            :check-on-click-node="true"
            :filter-node-method="filterNode"
            @check="deviceGroupSelected"
          >
          </el-tree>
        </div>
      </div>
    </div>
    <div class="flex mt-4 mb-4 justify-end px-4">
      <el-button type="danger" @click="reset()">Reset</el-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    dataTree: {
      type: Array
    },
    customer: {
      type: Array
    },
    form: {
      type: Object
    }
  },
  mounted() {
    this.setDefaultCustomerId()
  },
  data() {
    return {
      selectedTree: [],
      selectedCust: [],
      filterText: '',
      defaultProps: {
        children: 'children',
        label: 'Name'
      }
    }
  },
  methods: {
    reset() {
      this.form.customerId = ''
      this.form.tenant = ''
      this.$emit('reset')
    },
    validateDate() {
      if (this.form.startDate != '' && this.form.endDate != '') {
        let temp1 = new Date(this.startDate)
        let temp2 = new Date(this.endDate)
        if (temp1 > temp2) {
          this.form.endDate = ''
          this.alertMessage('End Period must be greater than Start Period')
        }
      }
    },
    filterNode(value, data) {
      if (!value) return true
      return data.Name.indexOf(value) !== -1
    },
    deviceGroupSelected(value, data) {
      this.$emit('deviceGroupSelected', value, data)
    },
    setDefaultCustomerId() {
      if (this.isCustomer) {
        this.form.customerId = this.user.CustomerName
          ? this.user.CustomerName[0]
          : ''

        this.$emit('fetchCustomerDevice', this.form.customerId)
      }
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    },
    dataTree(val) {
      if (val) {
        this.$refs.tree.setCheckedKeys(
          Array.isArray(this.form.deviceDceIds)
            ? this.form.deviceDceIds
            : [this.form.deviceDceIds]
        )
      }
    },
    'form.customerId': function (val) {
      if (val) {
        this.$emit('fetchCustomerDevice', val)
      }
    }
  },
  computed: {
    isCustomer() {
      return this.$store.state.auth.isCustomer
    },
    user() {
      return this.$store.state.auth.userData
    }
  }
}
</script>

<style scoped>
.el-select {
  width: 100% !important;
}

.max-h-72 {
  max-height: 18rem;
}
</style>
